module.exports = __webpack_public_path__ + "img/filter.d81db7a1.svg";